import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

export const rolesApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1Rbac: {
      providesTags: ['Rbac_Config', 'USER_CHANGED'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    getApiV1RbacRoles: {
      providesTags: ['Group_Roles', 'USER_CHANGED'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    postApiV1RbacRoles: {
      invalidatesTags: ['Group_Roles'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled, 'Role created successfully')
      },
    },
    putApiV1RbacRolesByRoleId: {
      invalidatesTags: ['Group_Roles'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled, 'Role updated successfully')
      },
    },
    deleteApiV1RbacRolesByRoleName: {
      invalidatesTags: ['Group_Roles'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled, 'Role deleted successfully')
      },
    },
  },
})

export const {
  useGetApiV1RbacQuery,
  useGetApiV1RbacRolesQuery,
  usePostApiV1RbacRolesMutation,
  usePutApiV1RbacRolesByRoleIdMutation,
  useDeleteApiV1RbacRolesByRoleNameMutation,
} = rolesApi
